import React from 'react'
import { useSwipeable } from 'react-swipeable';

export const Swipeable = ({children, className, ...props}) => {
  const handlers = useSwipeable(props);
  return (<div className={className} { ...handlers }>{children}</div>);
}